import { vivaStatus, VivaStatus } from '../../../dtos';

export const durchgangListingSnackbarsContent = {
  successTitle: 'Status-Änderung erfolgreich',
  errorTitle: 'Status-Änderung fehlgeschlagen',

  successMessages: {
    [vivaStatus.IN_PLANUNG]: (count: number) =>
      `${count} Durchgang(gänge) wurde(n) erfolgreich auf den Status 'in Planung' geändert.`,
    [vivaStatus.IM_AUSSCHREIBUNGSPORTAL]: (count: number) =>
      `${count} Durchgang(gänge) wurde(n) erfolgreich zum Ausschreibungsportal geschickt.`,
    [vivaStatus.ABGESCHLOSSEN]: (count: number) =>
      `${count} Durchgang(gänge) wurde(n) erfolgreich auf den Status 'Planung abgeschlossen' geändert.`,
    [vivaStatus.FREIGEGEBEN]: (count: number) =>
      `${count} Durchgang(gänge) wurde(n) erfolgreich auf den Status 'Planung freigegeben' geändert und nach SAP übermittelt.`,
  } satisfies Record<VivaStatus, (count: number) => string>,

  errorMessages: {
    [vivaStatus.IN_PLANUNG]: (count: number) =>
      `${count} Durchgang(gänge) konnte(n) aufgrund von Fehlern nicht auf den Status "in Planung" geändert werden.`,
    [vivaStatus.IM_AUSSCHREIBUNGSPORTAL]: (count: number) =>
      `${count} Durchgang(gänge) konnte(n) aufgrund von Fehlern nicht zum Ausschreibungsportal geschickt werden.`,
    [vivaStatus.ABGESCHLOSSEN]: (count: number) =>
      `${count} Durchgang(gänge) konnte(n) aufgrund von Fehlern nicht auf den Status "Planung abgeschlossen" geändert werden. Der Status wurde zurückgesetzt. Bitte prüfe die Durchgang(gänge):`,
    [vivaStatus.FREIGEGEBEN]: (count: number) =>
      `${count} Durchgang(gänge) konnte(n) aufgrund von Fehlern nicht freigegeben und nach SAP übertragen werden. Der Status wurde zurückgesetzt. Bitte prüfe die Durchgang(gänge):`,
  } satisfies Record<VivaStatus, (count: number) => string>,
};
